const toQuerystring = (data: Record<string, any>) =>
  `${new URLSearchParams(data)}`

export default toQuerystring
